import * as patient from '../services/Patients/PatientService'
import { ignoreGlobalError } from '../utilities/ReusableFunctions'
import types from './types'

export const A_GetFilteredPatients = data => dispatch => {
  dispatch({ type: types.PATIENT_SEARCH_VALUE, searchValue: data.patient })

  return patient
    .getFilteredPatients(data)
    .then(response => {
      dispatch({
        type: types.GET_FILTERED_PATIENTS.OK,
        data: response,
        nextQuery: data.nextQuery,
        searchValue: data.patient,
      })
      return response
    })
    .catch(error => {
      dispatch({ type: types.GET_FILTERED_PATIENTS.FAIL, error })
      return Promise.reject(error)
    })
}

export const A_GetDocumentsList = data => dispatch =>
  patient
    .getDocumentsList(data.clinicId, data.id)
    .then(response => {
      dispatch({
        type: types.GET_DOCUMENTS_LIST.OK,
        data: response,
        nextQuery: data.nextQuery,
      })
      return response
    })
    .catch(error => {
      dispatch({ type: types.GET_DOCUMENTS_LIST.FAIL, error })
      return Promise.reject(error)
    })

export const A_GetFilteredDocuments = data => dispatch =>
  patient
    .getFilteredDocuments(data)
    .then(response => {
      dispatch({
        type: types.GET_FILTERED_DOCUMENTS.OK,
        data: response,
        nextQuery: data.nextQuery,
      })
      return response
    })
    .catch(error => {
      dispatch({ type: types.GET_FILTERED_DOCUMENTS.FAIL, error })
      return Promise.reject(error)
    })

export const A_SetFilteredDocumentList = payload => ({
  type: types.SET_FILTERED_DOCUMENT_LIST,
  payload,
})

export const A_SetSelectedDocument = documentData => ({
  type: types.SET_SELECTED_DOCUMENT,
  document: documentData,
})

export const A_GetPatientDetail = (clinicId, patientId) => dispatch =>
  patient
    .getPatientDetail(clinicId, patientId)
    .then(response => {
      dispatch({ type: types.GET_PATIENT_DETAIL.OK, patient: response })
      return response
    })
    .catch(error => {
      dispatch({ type: types.GET_PATIENT_DETAIL.FAIL, error })
      return Promise.reject(error)
    })

export const A_GetPatientMedicalHistoryOptionsList = clinicId => dispatch =>
  patient
    .getPatientMedicalHistoryOptionsList(clinicId)
    .then(response => {
      dispatch({
        type: types.GET_PATIENT_MEDICAL_HISTORY_OPTIONS_LIST.OK,
        options: response,
      })
      return response
    })
    .catch(error => {
      dispatch({
        type: types.GET_PATIENT_MEDICAL_HISTORY_OPTIONS_LIST.FAIL,
        error,
      })
      return Promise.reject(error)
    })

export const A_SetSelectedPatient = patientData => ({
  type: types.SET_SELECTED_PATIENT,
  patient: patientData,
})

export const A_ResetSelectedPatient = () => ({
  type: types.RESET_SELECTED_PATIENT,
})

export const A_UpdatePatientDetail = (
  clinicId,
  patientId,
  patientData,
) => dispatch =>
  patient
    .updatePatientDetail(clinicId, patientId, patientData)
    .then(response => {
      dispatch({ type: types.UPDATE_PATIENT_DETAIL.OK, data: response })
      return response
    })
    .catch(error => {
      dispatch({
        type: types.UPDATE_PATIENT_DETAIL.FAIL,
        error,
        ignoreGlobalError: ignoreGlobalError(error),
      })
      return error
    })

export const A_AddPatientDocument = (
  clinicId,
  patientId,
  correspondenceData,
) => dispatch =>
  patient
    .addPatientDocument(clinicId, patientId, correspondenceData)
    .then(response => {
      dispatch({ type: types.ADD_PATIENT_DOCUMENT.OK, data: response })
      return response
    })
    .catch(error => {
      dispatch({ type: types.ADD_PATIENT_DOCUMENT.FAIL, error })
      return Promise.reject(error)
    })

export const A_AddCorrespondence = (
  clinicId,
  patientId,
  correspondenceData,
) => dispatch =>
  patient
    .addCorrespondence(clinicId, patientId, correspondenceData)
    .then(response => {
      dispatch({ type: types.ADD_CORRESPONDENCE.OK, data: response })
      return response
    })
    .catch(error => {
      dispatch({ type: types.ADD_CORRESPONDENCE.FAIL, error })
      return Promise.reject(error)
    })